import React, { useMemo } from "react"
import { Box, Breadcrumbs, Chip } from "@material-ui/core"
import HomeIcon from "@material-ui/icons/Home"
import { useHistory, Link as RouterLink } from "react-router-dom"
import useSmartFormat from "../i18n/useSmartFormat"
import adminMessages from "../pages/admin/adminMessage"
import { messages as wealthMessages } from "../pages/wealth/pages"
import { words } from "../i18n/lstrings"
import profilesMessages from "../pages/admin/users/userProfileMessage"

/**
 * See AdminRouter and AppRouter (for Documents) to get all routes
 */
const breadcrumbNameMap = {
  "/documents": { Icon: HomeIcon, label: "Documents" },
  "/documents/statements": { label: adminMessages.breadcrumbStatements },
  "/documents/forms": { label: adminMessages.breadcrumbForms },
  "/admin": { Icon: HomeIcon, label: "Admin" },
  "/admin/users": { label: words.users },
  "/admin/contacts": { label: adminMessages.breadcrumbContacts },
  "/admin/users/customer": { label: adminMessages.breadcrumbContacts },
  "/admin/profiles": { label: profilesMessages.userProfile },
  "/admin/pages": { label: adminMessages.breadcrumbPages },
  "/admin/pages/overview": { label: wealthMessages.wealthSynthesis },
  "/admin/pages/movements": { label: wealthMessages.wealthMovements },
  "/admin/pages/performance": { label: wealthMessages.wealthPerformance },
  "/admin/pages/composition": { label: wealthMessages.wealthComposition },
  "/admin/pages/consolidation": { label: wealthMessages.wealthConsolidation },
  "/admin/pages/simulations": { label: wealthMessages.wealthSimulations },
  "/admin/widgets": { label: words.widgets },
  "/admin/reports": { label: adminMessages.breadcrumbDocuments },
  "/admin/publish": { label: adminMessages.breadcrumbPublishReport },
  "/admin/forms": { label: adminMessages.breadcrumbForms },
  "/admin/config": { label: adminMessages.breadcrumbConfiguration },
  "/admin/mail": { label: adminMessages.breadcrumbMails },
  "/admin/mail/config": { label: adminMessages.breadcrumbMails },
  "/admin/license-configuration": {
    label: adminMessages.breadcrumbLicenseAgreementConfiguration
  }
}

export default function Navigation() {
  const { location } = useHistory()
  const format = useSmartFormat()

  // compute all paths
  const pathnames = useMemo(() => {
    return location.pathname.split("/").filter((x) => x)
  }, [location])

  return (
    <Box my={3}>
      <Breadcrumbs aria-label="breadcrumb">
        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1
          const to = `/${pathnames.slice(0, index + 1).join("/")}`
          const breadcrumbProps = breadcrumbNameMap[to]
          if (!breadcrumbProps) {
            throw new Error(`Declare breadcrumb for new route path ${to}`)
          }
          const { Icon, label } = breadcrumbProps

          return last ? (
            <Chip
              size="small"
              variant="outlined"
              color="secondary"
              icon={Icon && <Icon />}
              key={to}
              component="div"
              label={format(label)}
              clickable
            />
          ) : (
            <Chip
              size="small"
              variant="outlined"
              color="primary"
              icon={Icon && <Icon />}
              key={to}
              component={RouterLink}
              label={format(label)}
              to={to}
              clickable
            />
          )
        })}
      </Breadcrumbs>
    </Box>
  )
}
